<script setup lang="ts">
import { useTenantTheming } from "@/composables/useTenantTheming.ts";

defineOptions({
  name: "submissionFileUnavailable",
});

const { secondaryColor, secondaryColorClassLinks } = useTenantTheming();
</script>

<template>
  <div
    class="flex flex-col shadow-md rounded-lg p-4 break-words"
    data-testid="my-students-submission-file-unavailable"
  >
    <span
      >We've received the submission, but the file isn't available for download at this time. If you need a copy, please
      reach out to us at
      <a
        :class="[
          secondaryColor
            ? `${secondaryColorClassLinks}`
            : `${secondaryColorClassLinks} hover:text-teal-100 focus:text-teal-100`,
        ]"
        href="mailto:productsupport@apiexperience.com"
        class="font-semibold focus:underline"
      >
        productsupport@apiexperience.com</a
      >.</span
    >
  </div>
</template>
